import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/estado_orden_trabajo/getEstadosOrdenTrabajoActivo.php';

export default function getEstadosOrdenTrabajoActivo({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}